import { DateFormatter } from '@/support/DateFormatter';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component<DatePicker>({})
export default class DatePicker extends Vue {
  @Prop()
  protected value!: string;

  protected date = new DateFormatter();

  protected menu: boolean = false;

  public async mounted() {
    this.date.selectedDate = this.value;
  }

  protected clear(): void {
    this.date.clear();
    this.date.selectedDate = '';
    this.handleChange();
    this.$emit('click:clear');
  }

  protected handleChange() {
    this.$emit('input', this.date.selectedDate);
    this.$emit('change');
  }

  @Watch('value')
  protected dateChanged() {
    this.date.selectedDate = this.value;
  }
}
